export default {
  user (state) {
    return state.user
  },
  utilisateurs (state) {
    return state.utilisateurs
  },
  modalAdduser (state) {
    return state.modalAdduser
  },
  modalEdituser (state) {
    return state.modalEdituser
  },
  modalDeleteuser (state) {
    return state.modalDeleteuser
  },
  edituser (state) {
    return state.edituser
  },
  appartements (state) {
    return state.appartements
  },
  modalGestionappart (state) {
    return state.modalGestionappart
  },
  modalAddappart (state) {
    return state.modalAddappart
  },
  modalEditappart (state) {
    return state.modalEditappart
  },
  modalDeleteappart (state) {
    return state.modalDeleteappart
  },
  modalZoomimg (state) {
    return state.modalZoomimg
  },
  editappart (state) {
    return state.editappart
  },
  gestion (state) {
    return state.gestion
  },
  actualites (state) {
    return state.actualites
  },
  modalAddactualite (state) {
    return state.modalAddactualite
  },
  modalEditactualite (state) {
    return state.modalEditactualite
  },
  modalDeleteactualite (state) {
    return state.modalDeleteactualite
  },
  editactualite (state) {
    return state.editactualite
  },
  realisations (state) {
    return state.realisations
  },
  modalAddrealisation (state) {
    return state.modalAddrealisation
  },
  modalEditrealisation (state) {
    return state.modalEditrealisation
  },
  modalDeleterealisation (state) {
    return state.modalDeleterealisation
  },
  editrealisation (state) {
    return state.editrealisation
  },
  devis (state) {
    return state.devis
  },
  modalAdddevis (state) {
    return state.modalAdddevis
  },
  modalEditdevis (state) {
    return state.modalEditdevis
  },
  modalDeletedevis (state) {
    return state.modalDeletedevis
  },
  modalClosedevis (state) {
    return state.modalClosedevis
  },
  modalViewdevis (state) {
    return state.modalViewdevis
  },
  editdevis (state) {
    return state.editdevis
  },
  editimgzoom (state) {
    return state.editimgzoom
  }
}
